module.exports = __webpack_public_path__ + "static/media/dc_bob.19411cfa.png";